export enum IndicatorImageSource {
  URL = 'URL',
  Data = 'Data',
}
